const COOKIE = 'dacr-maintenance'

/**
 * Whether the platform is in maintenance mode, per the `maintenance` flag in
 * the `env_data` KVS key.
 *
 * The flag only exists at the edge, so the CloudFront viewer-response function
 * (apps/website/resources/maintenanceCookieFunction.yml) republishes it as this
 * cookie on every HTML response. `app.html` is served `text/html` + `no-cache`,
 * so each app boot reads a fresh value — but an SPA session never requests HTML
 * again, so this is deliberately a boot-time-only check.
 *
 * Absent, expired or `0` all read as "not in maintenance", so a stale cookie
 * fails safe (no modal) rather than locking a healthy app.
 */
export const isMaintenanceMode = (): boolean => {
  if (typeof document === 'undefined') return false

  return document.cookie.split('; ').some((entry) => entry === `${COOKIE}=1`)
}
